<h1 mat-dialog-title>TCP
</h1>
<div mat-dialog-content>
  <form novalidate [formGroup]="featureForm">
    <div style="display: flex; flex-direction: column; justify-content: space-between;">
      <mat-form-field>
        <mat-placeholder>{{tcpService.meta.TCP_in_APE.alias}}</mat-placeholder>
        <input matInput type="text" name="TCP in APE" formControlName="TCP_in_APE">
      </mat-form-field>
      <mat-form-field>
        <mat-placeholder>{{tcpService.meta.TCP_Effect.alias}}</mat-placeholder>
        <input matInput type="text" name="TCP Effect" formControlName="TCP_Effect">
      </mat-form-field>
      <mat-form-field>
        <mat-placeholder>{{tcpService.meta.Comments.alias}}</mat-placeholder>
        <input matInput type="text" name="Comments" formControlName="Comments">
      </mat-form-field>
      <!--<mat-form-field>-->
        <!--<mat-placeholder>{{tcpService.meta.ProjectFK.alias}}</mat-placeholder>-->
        <!--<input matInput type="text" name="ProjectFK" formControlName="ProjectFK">-->
      <!--</mat-form-field>-->
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button (click)="save()" cdkFocusInitial>Save</button>
</div>
